import { createSelector } from 'reselect';

import { type State } from 'reducers';

import { initialState } from './reducer';

const selectState = (state: State) => state.get('payrollApiPage') || initialState;

const selectPayroll = createSelector(
  selectState,
  (_state, payrollRunId: string) => payrollRunId,
  (state, payrollRunId) => state.statuses[payrollRunId]
);

export const selectDonationsForPayrollFetchStatus = createSelector(
  selectPayroll,
  (payroll) => payroll?.status
);

export const selectSelectedDonationForReschedule = createSelector(
  selectState,
  (state) => state.selectedDonation
);
